import { render, staticRenderFns } from "./CallAdmin.vue?vue&type=template&id=d2903886&scoped=true&"
import script from "./CallAdmin.vue?vue&type=script&lang=js&"
export * from "./CallAdmin.vue?vue&type=script&lang=js&"
import style0 from "./CallAdmin.vue?vue&type=style&index=0&id=d2903886&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2903886",
  null
  
)

export default component.exports